export default __webpack_public_path__ + "media/brands/samsung-466f265b.png";